export const CredentialsModal = require('../modals/Credentials').default,
  ForgotPasswordOverlay = require('./ForgotPassword').default,
  InfoTooltip = require('./InfoTooltip').default,
  StyledModal = require('./StyledModal').default;
